import { useState } from "react";
import DashLayout from "../components/DashLayout";
import { useAuth } from "../context/AuthContext";
import api, { formatApiErrorDetail } from "../lib/api";
import { toast } from "sonner";

export default function SettingsPage() {
    const { user } = useAuth();
    const [upgrading, setUpgrading] = useState(false);

    const handleUpgrade = async () => {
        setUpgrading(true);
        try {
            const { data } = await api.post("/auth/billing/checkout", { plan_id: "pro_plan" });
            if (data.checkout_url) {
                window.location.href = data.checkout_url;
            } else {
                toast.error("Failed to generate upgrade checkout link");
            }
        } catch (e) {
            toast.error(formatApiErrorDetail(e.response?.data?.detail) || "Failed to initialize upgrade");
        } finally {
            setUpgrading(false);
        }
    };

    return (
        <DashLayout title="SETTINGS" subtitle="dashboard / settings">
            <div className="grid lg:grid-cols-2 gap-0 border border-[#27272A]" data-testid="settings-panel">
                <div className="p-6 border-r border-[#27272A]">
                    <div className="label-mono text-[#00FF41] mb-2">// PROFILE</div>
                    <h3 className="font-display text-xl font-bold uppercase mb-4">Account</h3>
                    <Field k="Name" v={user?.name} testid="settings-name" />
                    <Field k="Email" v={user?.email} testid="settings-email" />
                    <Field k="Role" v={user?.role} testid="settings-role" />
                    <Field k="Member since" v={user?.created_at?.slice(0, 10)} testid="settings-created" />
                </div>
                <div className="p-6">
                    <div className="label-mono text-[#FF9900] mb-2">// PLAN</div>
                    <h3 className="font-display text-xl font-bold uppercase mb-4">Billing</h3>
                    <div className="border border-[#27272A] p-4 mb-4">
                        <div className="label-mono">CURRENT PLAN</div>
                        <div className="font-display text-3xl font-bold mt-1 text-[#00FF41]">{(user?.plan || "free").toUpperCase()}</div>
                        <div className="text-xs text-[#52525B] mt-1">
                            {user?.plan === "pro" ? "All developer features unlocked." : "1 reserved subdomain · live inspector · password protect."}
                        </div>
                    </div>
                    {user?.plan !== "pro" && user?.plan !== "enterprise" && (
                        <button 
                            disabled={upgrading}
                            onClick={handleUpgrade}
                            className="tf-btn w-full justify-center disabled:opacity-50" 
                            data-testid="upgrade-pro-btn"
                        >
                            {upgrading ? "INITIALIZING..." : "UPGRADE TO PRO · $9/MO"}
                        </button>
                    )}
                </div>
            </div>
        </DashLayout>
    );
}

function Field({ k, v, testid }) {
    return (
        <div className="mb-4">
            <div className="label-mono">{k}</div>
            <div className="font-mono text-[#FAFAFA] text-sm" data-testid={testid}>{v || "—"}</div>
        </div>
    );
}
